import Accordion from '@/components/accordion';
import Icon from '@/components/icon';
import UiModal from '@/components/modal';

export default {
    Accordion,
    Icon,
    UiModal,
};
